// extracted by mini-css-extract-plugin
export default {"div":"Classement_div__d9asV"};